import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-block-ui',
  styleUrls: ['./block-ui.component.scss'],
  template: `
    <div class="block-ui" *ngIf="loading">
      <section class="block-ui-message">
        <i
          class="pi pi-spin pi-spinner mb-3"
          style="font-size: 2rem; font-weight: bold"
        ></i>
        <h2 class="p-text-center">
          <ng-content></ng-content>
        </h2>
      </section>
    </div>
  `,
})
export class BlockUiComponent {
  /**
   * @description
   * This component is displayed in full screen to show the user that an action is being processed
   */

  /**
   * * Inputs
   */
  @Input() loading = false;
}
